import { filter } from 'lodash';
import * as t from './actionTypes'

const initialState = {
    localAppUsers: [],
    selectedLocalAppUserId: 0,
    localAppRoles: [],
    localAppEntities: [],
    selectedUserRoleDetails: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_LOCAL_APP_USERS:
            return Object.assign({}, state, {
                localAppUsers: action.payload
            });
        case t.LOCAL_USER_ROLE_DETAILS_LOADED:
            return Object.assign({}, state, {
                selectedUserRoleDetails: action.payload
            });
        case t.ADD_LOCAL_APP_USER:
            let new_users = state.localAppUsers.slice();
            new_users.push(action.payload);
            return Object.assign({}, state, {
                localAppUsers: new_users
            });
        case t.SET_SELECTED_LOCAL_APP_USER:
            return Object.assign({}, state, {
                selectedLocalAppUserId: action.payload,
                localAppRoles: []
            });
        case t.LOCAL_APPROLES_LOADED:
            return Object.assign({}, state, {
                localAppRoles: action.payload,
                selectedUserRoleDetails: {}
            });
        case t.LOCAL_APPENTITIES_LOADED:
            return Object.assign({}, state, {
                localAppEntities: action.payload
            });
        case t.SET_SELECTED_LOCAL_USER_ROLE_ACTIVE:
            let deep_clone1 = JSON.parse(JSON.stringify(state.selectedUserRoleDetails));
            deep_clone1.userRole.active = action.payload;
            return Object.assign({}, state, {
                selectedUserRoleDetails: deep_clone1
            });
        case t.SET_SELECTED_LOCAL_USER_ROLE_GLOBAL:
            let deep_clone2 = JSON.parse(JSON.stringify(state.selectedUserRoleDetails));
            deep_clone2.userRole.isGlobalRole = action.payload;
            return Object.assign({}, state, {
                selectedUserRoleDetails: deep_clone2
            });
        case t.SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_ACTIVE:
            let deep_clone3 = JSON.parse(JSON.stringify(state.selectedUserRoleDetails));
            //remove new item from existing array...
            deep_clone3.securableEntities = filter(deep_clone3.securableEntities, (current) => {
                return current.entityId !== action.payload.entityId || current.securableEntityId !== action.payload.securableEntityId;
            });
            //add it
            deep_clone3.securableEntities.push(action.payload);

            return Object.assign({}, state, {
                selectedUserRoleDetails: deep_clone3
            });
        case t.SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_INHERIT:
            let deep_clone4 = JSON.parse(JSON.stringify(state.selectedUserRoleDetails));
            //remove new item from existing array...
            deep_clone4.securableEntities = filter(deep_clone4.securableEntities, (current) => {
                return current.entityId !== action.payload.entityId;
            });
            //add it
            deep_clone4.securableEntities.push(action.payload);

            return Object.assign({}, state, {
                selectedUserRoleDetails: deep_clone4
            });
        default:
            return state
    }
}